import DeleteConfirmationDialog from "@/components/dialogs/DeleteConfirmationDialog";
import { ReturnCreationDialog } from "@/components/dialogs/ReturnCreationDialog";
import ReturnList from "@/components/return/ReturnList";
import CanceledReturnList from "@/components/return/CanceledReturnList";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Toaster } from "@/components/ui/toaster";
import { resetLitige } from "@/store/reducers/litigeReducer";
import { resetReturnHeader } from "@/store/reducers/returnHeaderReducer";
import { resetArticles } from "@/store/reducers/returnProductsReducer";
import { resetReturn } from "@/store/reducers/returnReducer";
import { RootState } from "@/store/store";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import FilterDialog from "@/components/dialogs/FilterDialog";
import { Roles } from "@/enums";

interface DashboardProps {
  // Define any props for the Dashboard component here
}

const Dashboard: React.FC<DashboardProps> = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const searchText = useSelector((state: RootState) => state.search.searchText);
  const [currentListValue, setCurrentListValue] = useState<string>("normal");
  const { filter } = useSelector((state: RootState) => state.filter);
  const { roles } = useSelector((state: RootState) => state.authentication);
  const isRefreshing = useSelector(
    (state: RootState) => state.refresh.isRefreshing,
  );

  const resetPersistStates = () => {
    dispatch(resetReturnHeader());
    dispatch(resetArticles());
    dispatch(resetReturn());
    dispatch(resetLitige());
  };

  useEffect(() => {
    resetPersistStates();
  }, []);

  useEffect(() => {
    if (
      location.state &&
      location.state.tab === "cancelled" &&
      location.state.tab !== null
    ) {
      setCurrentListValue("cancelled");
      navigate(".", { state: null, replace: true });
    } else {
      setCurrentListValue("normal");
    }
  }, []);

  return (
    <>
      <ScrollArea className="flex-grow sm:px-2" showScrollIndicator>
        <Tabs value={currentListValue} className="w-full sm:px-2">
          {roles.includes(Roles.WAREHOUSE_ROLE) && (
            <TabsList className="flex-col h-full sm:flex-row w-full">
              <TabsTrigger
                className="w-full"
                value="normal"
                onClick={() => {
                  setCurrentListValue("normal");
                }}
              >
                Tournées vendeurs
              </TabsTrigger>
              <TabsTrigger
                className="w-full"
                value="cancelled"
                onClick={() => {
                  setCurrentListValue("cancelled");
                }}
              >
                Tournées annulées vendeur
              </TabsTrigger>
            </TabsList>
          )}

          <TabsContent value="normal">
            <div className="sm:px-2">
              <ReturnList
                statusId={filter?.statusId}
                sellerName={filter?.sellerName}
                searchText={searchText}
                roles={roles}
                isRefreshing={isRefreshing}
              />
            </div>
          </TabsContent>
          <TabsContent value="cancelled">
            <div className="px-2">
              <CanceledReturnList
                sellerName={filter?.sellerName}
                statusId={filter?.statusId}
                searchText={searchText}
                isRefreshing={isRefreshing}
              />
            </div>
          </TabsContent>
        </Tabs>
      </ScrollArea>
      <ReturnCreationDialog />
      <DeleteConfirmationDialog />
      <FilterDialog />
      <Toaster />
    </>
  );
};

export default Dashboard;
